export enum Reviewer {
  AGNES_MARIE_GUNDEM = 'agnes-marie-gundem',
  HAAKON_FOLKENBORG_VODAL = 'haakon-folkenborg-vodal',
  SILJE_GLIDSETH = 'silje-glidseth',
  THORBJØRN_BROOK_STEEN = 'thorbjørn-brook-steen',
}

export const reviewers = [
  {
    imageSrcKey: 'mentor-on-demand/reviews/agnes-marie-gundem.png',
    key: Reviewer.AGNES_MARIE_GUNDEM,
    name: 'Agnes Marie Gundem',
  },
  {
    imageSrcKey: 'mentor-on-demand/reviews/haakon-folkenborg-vodal.png',
    key: Reviewer.HAAKON_FOLKENBORG_VODAL,
    name: 'Haakon Folkenborg Vodal',
  },
  {
    imageSrcKey: 'mentor-on-demand/reviews/silje-glidseth.png',
    key: Reviewer.SILJE_GLIDSETH,
    name: 'Silje Glidseth',
  },
  {
    imageSrcKey: 'mentor-on-demand/reviews/thorbjørn-brook-steen.png',
    key: Reviewer.THORBJØRN_BROOK_STEEN,
    name: 'Thorbjørn Brook Steen',
  },
]
